import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { Modal } from "reactstrap";
import { createNotification } from "../../Common/CreateNotification";
import { useDispatch } from "react-redux";
import { toggleLoading } from "../../../Redux/reducers/loadingSlice";
import { baseUrl } from "../../../shared/baseUrl";
import { TOKEN_KEY } from "../../../Utils/Constants";

const ChangePassword = ({ isOpen, onClose }) => {

    const dispatch = useDispatch();
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const resetPassword = () => {
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
    }

    const handleChangePassword = async (e) => {
        e.preventDefault();
        dispatch(toggleLoading(true));

        await fetch(baseUrl + 'change-password-from-old', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
            },
            body: JSON.stringify({
                old_password: oldPassword,
                new_password: newPassword
            }),
        })
            .then(response => response.json())
            .then(res => {
                if (res.success) {
                    createNotification('success', 'Password Changed Successfully');
                    resetPassword();
                    onClose();
                    dispatch(toggleLoading(false));
                } else {
                    createNotification('error', res.message);
                    dispatch(toggleLoading(false));
                }
            })
            .catch(e => {
                createNotification('error', 'Failed to change password!');
                dispatch(toggleLoading(false));
            });

    }

    return (
        <Modal isOpen={isOpen} className='position-relative' centered>
            <div onClick={onClose} className='position-absolute cursor-pointer' style={{ zIndex: 10, top: 6, right: 10 }}>
                <FaTimes size={20} />
            </div>
            <div className='p-3 sc-modal-content'>
                <h4 className='text-left pb-3'>Change Password</h4>
                <form onSubmit={handleChangePassword} className='g-3 mt-3' autoComplete="off">
                    <div className="mb-3">
                        <label className="form-label fw-bold">Old Password</label>
                        <input autoComplete="off" required type="password" className="form-control" placeholder='Your Old Password' value={oldPassword} onChange={(e) => { setOldPassword(e.target.value); }} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label fw-bold">New Password</label>
                        <input autoComplete="off" required type="password" className="form-control" placeholder='Your New Password' value={newPassword} onChange={(e) => { setNewPassword(e.target.value); }} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label fw-bold">Confirm Password</label>
                        <input autoComplete="off" required type="password" className="form-control" placeholder='Confirm New Password' value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value); }} />
                        <p className={`small text-danger ${newPassword !== "" && confirmPassword !== "" && newPassword !== confirmPassword ? '' : 'd-none'}`}>Password doesn't match!</p>
                    </div>
                    <div className="col-12 d-flex justify-content-start">
                        <button disabled={newPassword !== "" && confirmPassword !== "" && oldPassword !== "" && newPassword === confirmPassword ? false : true} type="submit" className="btn btn-primary">Change Password</button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}

export default ChangePassword;